import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  IconButton,
  Typography,
  Chip,
  Dialog,
  DialogContent,
  Skeleton,
  Fab,
  Tooltip,
  Backdrop,
  Grid,
  InputAdornment,
  CircularProgress,
  Modal,
  useTheme,
  useMediaQuery,
  Paper,
  Rating,
  TextField,
} from "@mui/material";
import {
  Add,
  Call,
  Close,
  Email,
  Facebook,
  GetApp,
  Instagram,
  KeyboardArrowRight,
  LinkedIn,
  LocationOn,
  Phone,
  Star,
  SubdirectoryArrowRight,
  Twitter,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { fonts, colors, size } from "../ColorFont/color";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../CSS/styles.css";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { url } from "../ConstUrl/Url";
import Carousel from "react-material-ui-carousel";
import ContactPopup from "../components/ViewDetails";
import { useNavigate } from "react-router-dom";
import { useActivePage } from "@toolpad/core/useActivePage";
import SignUp from "../auth/SignUp";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { KrushiSetu } from "../constants/constant";
import AddPlots from "../screens/FarmerScreen/AddPlots";
import FarmerDashboard from "../screens/FarmerScreen/FarmerDashboard";
import CropDetailsModal from "../components/CropDetailsModal";
import UnifiedCropCard from "../components/UnifiedCropCard";
import axios from "axios";
import { toast } from "react-toastify";
import { SkeletonDashboard } from "../components/common/Skeletons";
import { 
  IconPlus, 
  IconCube, 
  IconBolt, 
  IconLeaf, 
  IconChevronRight, 
  IconBox, 
  IconSearch, 
  IconHeart, 
  IconEye, 
  IconShoppingBag,
  IconUsers,
  IconPlant,
  IconShieldCheck,
  IconLayoutDashboard,
  IconChartLine,
  IconClock
} from '@tabler/icons-react';

const ActionCard = ({ icon: Icon, iconBg, title, onClick }) => (
  <Box
      onClick={onClick}
      sx={{
          flex: { xs: '1 1 calc(50% - 10px)', sm: '1 1 calc(25% - 15px)', md: '1 1 0' },
          maxWidth: { xs: 'calc(50% - 10px)', sm: 'calc(25% - 15px)', md: '100%' },
          minHeight: '136px',
          py: 3,
          backgroundColor: '#FFFFFF',
          borderRadius: '24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          cursor: 'pointer',
          border: `1px solid #E0E5EB`,
          boxShadow: '0px 1px 2px rgba(0,0,0,0.05)',
          transition: 'all 0.2s',
          '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
          }
      }}
  >
      <Box sx={{
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          backgroundColor: iconBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#FFFFFF'
      }}>
          <Icon size={22} stroke={2} />
      </Box>
      <Typography sx={{
          fontFamily: fonts.poppins,
          fontSize: '14px',
          fontWeight: 600,
          color: colors.text_dark || '#000000',
          lineHeight: '1.2',
          textAlign: 'center',
          px: 1
      }}>
          {title}
      </Typography>
  </Box>
);

const StatCard = ({ icon: Icon, title, value, color }) => (
  <Card sx={{ 
      height: '100%', 
      borderRadius: '24px', 
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
      border: '1px solid #F1F5F9',
      overflow: 'hidden'
  }}>
      <CardContent sx={{ p: 2.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
              <Box sx={{ 
                  p: 1, 
                  borderRadius: '12px', 
                  backgroundColor: color + '15',
                  color: color,
                  display: 'flex'
              }}>
                  <Icon size={22} />
              </Box>
              <Typography sx={{ 
                  fontFamily: fonts.poppins, 
                  fontSize: '13px', 
                  fontWeight: 600, 
                  color: '#64748B' 
              }}>
                  {title}
              </Typography>
          </Box>
          <Typography sx={{ 
              fontFamily: fonts.poppins, 
              fontSize: '28px', 
              fontWeight: 800, 
              color: '#1E293B' 
          }}>
              {value}
          </Typography>
      </CardContent>
  </Card>
);

const farmerTranslations = {
    en: { myListings: "My Listings", viewAll: "View All", noListingsYet: "No listings yet" },
    hi: { myListings: "मेरी लिस्टिंग", viewAll: "सभी देखें", noListingsYet: "अभी तक कोई सूची नहीं" },
    mr: { myListings: "माझ्या सूची", viewAll: "सर्व पहा", noListingsYet: "अद्याप कोणत्याही याद्या नाहीत" }
};

const FarmerDashboardOnlyRecent = ({ userData, onDeleteSuccess, onEdit, handleCropClick }) => {
    const { i18n } = useTranslation();
    const [crops, setCrops] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const langCode = i18n.language || 'en';
    const currentLang = langCode.startsWith('hi') ? 'hi' : langCode.startsWith('mr') || langCode.startsWith('mar') ? 'mr' : 'en';
    const tLocal = farmerTranslations[currentLang];

    useEffect(() => {
        const fetchCrops = async () => {
            if (!userData?._id) return;
            try {
                const response = await fetch(`${url}/api/plots?user=${userData._id}`);
                const data = await response.json();
                if (data && data.paginatedPlots) {
                    const sortedCrops = data.paginatedPlots.sort((a, b) => {
                        const aSpons = a.isSponsored || a.isSponsered;
                        const bSpons = b.isSponsored || b.isSponsered;
                        if (aSpons && !bSpons) return -1;
                        if (!aSpons && bSpons) return 1;
                        return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
                    });
                    setCrops(sortedCrops.slice(0, 3));
                }
            } catch (err) {
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchCrops();
    }, [userData]);

    if (!userData || crops.length === 0 && !isLoading) return null;

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                <Typography sx={{ fontFamily: fonts.poppins, fontWeight: 700, fontSize: '20px', color: colors.text_dark }}>
                    {tLocal.myListings}
                </Typography>
            </Box>
            {isLoading ? (
                <SkeletonDashboard />
            ) : (
                <Grid container spacing={4}>
                    {crops.map((crop) => (
                        <Grid item xs={12} sm={6} md={4} key={crop._id}>
                            <UnifiedCropCard
                                crop={crop}
                                userData={userData}
                                onDetails={handleCropClick}
                                onDeleteSuccess={onDeleteSuccess}
                                onEdit={onEdit}
                                isExplore={true}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    );
};

const testimonials = [
  {
    name: "Vallabh Ghatge",
    review:
      "This is very good and responsive among all this type agricultural online shopping sites",
  },
  {
    name: "John Doe",
    review: "Amazing service and fast delivery. Highly recommend!",
  },
  {
    name: "Jane Smith",
    review: "Quality products at reasonable prices. Love it!",
  },
  {
    name: "Raj Patel",
    review: "Very user-friendly and excellent customer support.",
  },
  {
    name: "Anita Sharma",
    review: "Best online store for agricultural products.",
  },
];

const labels = {
  0.5: "Useless",
  1: "Useless+",
  1.5: "Poor",
  2: "Poor+",
  2.5: "Ok",
  3: "Ok+",
  3.5: "Good",
  4: "Good+",
  4.5: "Excellent",
  5: "Excellent+",
};

const placeholders = ["new plots", "what you need...", "something new ?"];

const Home = ({
  role,
  userData,
  router,
  setUserData,
  handleListPlotPage,
  aboutUsPage,
  termsConditionPage,
  privacyPolicyPage,
  faqsPage,
  refundPolicyPage,
  shippingPolicyPage,
  cancellationPolicyPage,
  supportPage,
  settingsPage,
  wishlistPage,
  viewedPlotsPage,
}) => {
  // const searchInputRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const userId = userData?._id;
  const { t } = useTranslation(['dashboard', 'common']);
  const [purchasedPlots, setPurchasedPlots] = useState(null);
  const [images, setImages] = useState([]);
  const [plots, setPlots] = useState([]);
  const [selectedPlot, setSelectedPlot] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const [isUpgradePopupOpen, setOpenUpgradePopup] = useState(false);
  const [open, setOpen] = useState(false);
  const value = 5;
  const [isBuyer, setIsBuyer] = useState(false);
  const [isSeller, setIsSeller] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminStats, setAdminStats] = useState(null);
  const [loadingStats, setLoadingStats] = useState(false);
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleFreePostingClick = () => {
    if (!userData) {
      setOpenLogin(true);
      return;
    }
    
    if (isBuyer) {
      toast.info(t('dashboard:sellerFeatureOnly'), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
    
    navigate('/add-crop-step-1');
  };

  const handleActionClick = (action) => {
    switch (action) {
      case 'sell':
        navigate('/add-crop-step-1');
        break;
      case 'listings':
        navigate('/my-listings');
        break;
      case 'boost':
        navigate(isSeller ? '/farmer/boost' : '/buyer/boost');
        break;
      case 'carbon':
        navigate('/carbon-credits');
        break;
      case 'search':
        navigate('/explore');
        break;
      case 'wishlist':
        navigate('/wishlist');
        break;
      case 'viewed':
        navigate('/viewed-plots');
        break;
      case 'plans':
        navigate('/purchase-history');
        break;
      case 'verify-carbon':
        navigate('/manage-carbon-proofs');
        break;
      case 'manage-crops':
        navigate('/manage-crops');
        break;
      case 'manage-plans':
        navigate('/manage-plans');
        break;
      case 'manage-dashboard':
        navigate('/manage-dashboard');
        break;
      default:
        console.warn("Unknown action:", action);
    }
  };

  const [displaySponsored, setDisplaySponsored] = useState([]);
  const [isChange, setIsChange] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [showMoreBtn, setShowMoreBtn] = useState(false);
  const [showManageBtn, setShowManageBtn] = useState(false);
  const [highlightButton, setHighlightButton] = useState(true);
  const [addPlots, setAddPlots] = useState(false);
  const [showBtn, setShowBtn] = useState(true);
  const [showCard, setShowCard] = useState(true);
  const [isRender, setIsRender] = useState(false);
  const [isLoadingPlots, setIsLoadingPlots] = useState(true);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [homeSearchQuery, setHomeSearchQuery] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setHighlightButton(false);
    }, 5000); // Highlight for 5 seconds (adjust as needed)

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (role === "Buyer") {
      setIsBuyer(true);
      setIsSeller(false);
      setIsAdmin(false);
      setShowMoreBtn(true);
      setShowManageBtn(false);
    } else if (role === "Seller" || role === "Supplier") {
      setIsSeller(true);
      setIsBuyer(false);
      setIsAdmin(false);
      setShowManageBtn(true);
      setShowMoreBtn(false);
    } else if (role === "Admin") {
      setIsAdmin(true);
      setIsBuyer(false);
      setIsSeller(false);
      setShowManageBtn(true);
      setShowMoreBtn(false);
    } else {
      setIsBuyer(true);
      setIsSeller(true);
      setShowMoreBtn(false);
      setShowManageBtn(true);
    }
  }, [role]);

  useEffect(() => {
    if (isAdmin) {
      const fetchAdminStats = async () => {
        try {
          setLoadingStats(true);
          const response = await fetch(`${url}/api/admin/stats`);
          const data = await response.json();
          setAdminStats(data);
        } catch (err) {
          console.error("Error fetching stats:", err);
        } finally {
          setLoadingStats(false);
        }
      };
      fetchAdminStats();
    }
  }, [isAdmin]);

  const handleFindNowClick = () => {
    if (!userData) {
      handleOpen();
    } else {
      console.log("logged in");
      handleListPlotPage();
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholderIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
    }, 1000); // Change placeholder every 3 seconds

    return () => clearInterval(interval);
  }, []);

  const fetchSponsoredPlots = async () => {
    try {
      setIsLoadingPlots(true);
      const response = await fetch(`${url}/api/display-plots-home`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data); // Check the API response
      setDisplaySponsored(data);
    } catch (error) {
      console.error("Error fetching sponsored plots:", error);
    } finally {
      setIsLoadingPlots(false);
    }
  };

  const Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  useEffect(() => {
    if (userData) {
      handleClose();
    }
    fetchViewedPlots();
  }, [userId]);

  const fetchViewedPlots = () => {
    if (userId) {
      fetch(`${url}/api/purchasedPlots/${userId}`)
        .then((response) => response.json())
        .then((data) => {
          console.log("purchasedPlots data:", data);
          setPurchasedPlots(data.purchasedPlots);
        })
        .catch((error) =>
          console.error("Error fetching purchasedPlots:", error)
        );
    }
  };

  const handleCloseLogin = () => {
    setOpenLogin(false);
  };
  const handleOpen = () => {
    setOpenLogin(true);
  };
  useEffect(() => {
    if (userData) {
      handleCloseLogin();
    }
  }, [userId]);
  const handleGetContact = (plot) => {
    const userId = userData?._id;
    console.log("user data to test", userData);
    const plotId = plot?._id;

    if (!userData) {
      handleOpen();
      return;
    } else if (userData.noOfContacts <= 0) {
      if (
        !userData?.purchasedPlots?.some(
          (purchasedPlot) => purchasedPlot.plotId === plotId
        )
      ) {
        navigate('/buyer/boost', { state: { cropData: plot } });
        return;
      }
    }

    fetch(`${url}/api/view-plot-details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId,
        plotId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "Plot details already viewed") {
          setSelectedPlot(plot);
          setOpenPopup(true);
          setIsDetailsModalOpen(false); // Close details modal if open
        } else {
          setUserData(data.user);
          setSelectedPlot(plot);
          setOpenPopup(true);
          setIsDetailsModalOpen(false); // Close details modal if open
        }
      })
      .catch((error) => console.error(error));
  };

  const handleOpenDetails = (plot) => {
    setSelectedPlot(plot);
    setIsDetailsModalOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteSuccess = (plotId) => {
    setDisplaySponsored((prev) => prev.filter((p) => p._id !== plotId));
    setPlots((prev) => prev.filter((p) => p._id !== plotId));
  };

  const handleEdit = (plot) => {
    navigate("/add-crop-step-1", {
      state: {
        isEdit: true,
        cropId: plot._id,
        cropData: plot,
      },
    });
  };

  const handleBoost = (plot) => {
    // Boost is now handled internally by UnifiedCropCard popup.
    // No redirection needed to /farmer/boost.
  };
  useEffect(() => {
    fetch(`${url}/api/get-banner-images`).then((response) =>
      response.json().then((data) => setImages(data))
    );
  }, []);

  useEffect(() => {
    fetchSponsoredPlots();
  }, []);

  return (
    <>
      <CropDetailsModal
        open={isDetailsModalOpen}
        onClose={() => setIsDetailsModalOpen(false)}
        crop={selectedPlot}
        userData={userData}
        onGetContact={handleGetContact}
      />

      <Box sx={{ background: '#FFFFFF', p: 0, m: 0, minHeight: '100vh', width: '100%' }}>
        {/* Banner section */}
        <Box sx={{ position: "relative", width: '100%' }}>
          {images.length === 0 ? (
            <Skeleton
              variant="rectangular"
              width="100%"
              height={isMobile ? "180px" : "320px"}
            />
          ) : (
            <Box sx={{ position: "relative" }}>
              <Carousel
                autoPlay={true}
                interval={4000}
                timeout={800}
                animation="slide"
                indicators={false}
                navButtonsAlwaysVisible={!isMobile}
                swipe={true}
                cycleNavigation={true}
                navButtonsProps={{
                  style: {
                    backgroundColor: 'rgba(255,255,255,0.9)',
                    color: colors.primary_dark,
                    padding: isMobile ? 2 : 4,
                    zIndex: 3,
                    boxShadow: '0px 4px 10px rgba(0,0,0,0.15)',
                  },
                }}
                sx={{
                   height: isMobile ? "180px" : "320px",
                   '& .MuiPaper-root': { height: '100%' }
                }}
              >
                {images.map((image, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      position: "relative",
                      height: isMobile ? "180px" : "320px",
                    }}
                  >
                    <img
                      src={`${url}/${image.url}`}
                      alt={image.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        position: "relative",
                        zIndex: 0,
                      }}
                    />
                  </Box>
                ))}
              </Carousel>
            </Box>
          )}
        </Box>

        {/* Content Container */}
        <Box sx={{ maxWidth: '1600px', margin: '0 auto', px: { xs: 2, md: 3 }, py: 4 }}>
          
          {/* Welcome Message */}
          <Box sx={{ mb: { xs: 8, sm: 12 } }}>
            <Typography sx={{
              fontFamily: fonts.poppins,
              fontWeight: 700,
              fontSize: { xs: '24px', md: '32px' },
              color: '#171C17',
              mb: 1
            }}>
              {t('dashboard:welcomeBack')}, {userData?.firstName && userData?.lastName ? `${userData.firstName} ${userData.lastName}` : (userData?.firstName || userData?.name || userData?.username || 'User')}
            </Typography>
            <Typography sx={{
              fontFamily: fonts.poppins,
              fontSize: '16px',
              color: '#6D786D'
            }}>
              {isAdmin ? t('dashboard:adminOverviewSub') : isBuyer ? t('dashboard:findBestCrops') : t('dashboard:manageProduce')}
            </Typography>
          </Box>

          {/* Admin Stats Section */}
          {isAdmin && adminStats && (
            <Grid container spacing={3} sx={{ mb: { xs: 8, sm: 12 } }}>
                <Grid item xs={12} sm={6} md={3}>
                    <StatCard 
                        icon={IconUsers} 
                        title={t('dashboard:totalSellers')} 
                        value={adminStats?.totalSellers || 0} 
                        color={colors.primary} 
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <StatCard 
                        icon={IconUsers} 
                        title={t('dashboard:totalBuyers')} 
                        value={adminStats?.totalBuyers || 0} 
                        color="#3B82F6" 
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <StatCard 
                        icon={IconPlant} 
                        title={t('dashboard:totalCrops')} 
                        value={adminStats?.totalCrops || 0} 
                        color="#F59E0B" 
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <StatCard 
                        icon={IconClock} 
                        title={t('dashboard:pendingProofs')} 
                        value={adminStats?.pendingProofs || 0} 
                        color="#EF4444" 
                    />
                </Grid>
            </Grid>
          )}

          {/* Action Cards Section */}
          {userData && (
          <Box sx={{ mb: { xs: 10, sm: 14 } }}>
            <Typography sx={{
                fontFamily: fonts.poppins,
                fontWeight: 700,
                fontSize: { xs: '20px', md: '24px' },
                color: '#1C252E',
                mb: 3
            }}>
                {t('dashboard:quickActions') || 'Quick Actions'}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              {isSeller && (
                <>
                  <ActionCard 
                    icon={IconPlus} iconBg={colors.primary} title={t('dashboard:sellCrop')} 
                    onClick={() => handleActionClick('sell')} 
                  />
                  <ActionCard 
                    icon={IconCube} iconBg={'#3B82F6'} title={t('dashboard:myListings')} 
                    onClick={() => handleActionClick('listings')} 
                  />
                  <ActionCard 
                    icon={IconBolt} iconBg={'#F59E0B'} title={t('dashboard:boostPlans')} 
                    onClick={() => handleActionClick('boost')} 
                  />
                  <ActionCard 
                    icon={IconLeaf} iconBg={'#00B6E9'} title={t('dashboard:carbonCredits')} 
                    onClick={() => handleActionClick('carbon')} 
                  />
                </>
              )}
              {isBuyer && (
                <>
                  <ActionCard 
                    icon={IconEye} iconBg={'#10B981'} title={t('dashboard:viewedPlots')} 
                    onClick={() => handleActionClick('viewed')} 
                  />
                  <ActionCard 
                    icon={IconShoppingBag} iconBg={'#F59E0B'} title={t('dashboard:buyedPlans')} 
                    onClick={() => handleActionClick('plans')} 
                  />
                  <ActionCard 
                    icon={IconBolt} iconBg={'#F59E0B'} title={t('dashboard:boostPlans')} 
                    onClick={() => handleActionClick('boost')} 
                  />
                  <ActionCard 
                    icon={IconHeart} iconBg={'#EF4444'} title={t('common:wishlist')} 
                    onClick={() => handleActionClick('wishlist')} 
                  />
                </>
              )}
              {isAdmin && (
                <>
                  <ActionCard 
                    icon={IconLeaf} iconBg={'#10B981'} title={t('dashboard:verifyCarbonProofs')} 
                    onClick={() => handleActionClick('verify-carbon')} 
                  />
                  <ActionCard 
                    icon={IconShieldCheck} iconBg={'#6366F1'} title={t('dashboard:manageCategories')} 
                    onClick={() => handleActionClick('manage-crops')} 
                  />
                  <ActionCard 
                    icon={IconChartLine} iconBg={'#F59E0B'} title={t('dashboard:managePlans')} 
                    onClick={() => handleActionClick('manage-plans')} 
                  />
                  <ActionCard 
                    icon={IconLayoutDashboard} iconBg={'#3B82F6'} title={t('dashboard:dashboardBanners')} 
                    onClick={() => handleActionClick('manage-dashboard')} 
                  />
                </>
              )}
            </Box>
          </Box>
          )}

          {/* Boost Your Listings Banner (Specific for Sellers) */}
          {isSeller && (
              <Box sx={{
                  width: '100%',
                  height: { xs: 'auto', sm: '188px' },
                  minHeight: '188px',
                  borderRadius: '24px',
                  background: colors.boost_bg || 'linear-gradient(90deg, #F59E0B 0%, #F97316 100%)',
                  p: { xs: '24px 20px', sm: '32px 48px' },
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: { xs: 3, sm: 0 },
                  color: '#FFFFFF',
                  mb: { xs: 10, sm: 14 },
                  boxShadow: '0px 10px 25px rgba(245, 158, 11, 0.2)'
              }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', maxWidth: '450px' }}>
                      <Typography sx={{
                          fontFamily: fonts.poppins,
                          fontWeight: 700,
                          fontSize: { xs: '24px', md: '30px' },
                          lineHeight: '1.2',
                          letterSpacing: '-0.75px'
                      }}>
                          {t('dashboard:boostYourListings')}
                      </Typography>
                      <Typography sx={{
                          fontFamily: fonts.poppins,
                          fontWeight: 400,
                          fontSize: '16px',
                          lineHeight: '24px',
                          opacity: 0.95
                      }}>
                          {t('dashboard:boostYourListingsSub')}
                      </Typography>
                      <Box sx={{ mt: '12px' }}>
                          <Button
                              onClick={() => handleActionClick('boost')}
                              sx={{
                                  height: '36px',
                                  padding: '8px 20px',
                                  borderRadius: '47px',
                                  backgroundColor: '#FFFFFF',
                                  color: '#F59E0B',
                                  textTransform: 'none',
                                  fontFamily: fonts.poppins,
                                  fontWeight: 700,
                                  fontSize: '14px',
                                  '&:hover': {
                                      backgroundColor: '#FFFFFF',
                                      transform: 'scale(1.05)'
                                  },
                                  transition: 'transform 0.2s',
                                  boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)'
                              }}
                              endIcon={<IconChevronRight size={16} stroke={2.5} />}
                          >
                              {t('dashboard:viewPlans')}
                          </Button>
                      </Box>
                  </Box>

                  {/* Visual Illustration spacing */}
                  <Box sx={{ 
                    display: { xs: 'none', sm: 'flex' }, 
                    flex: 1, 
                    justifyContent: 'flex-end',
                    pr: 4
                  }}>
                      <IconBolt size={100} stroke={1.5} style={{ opacity: 0.3, transform: 'rotate(15deg)' }} />
                  </Box>
              </Box>
          )}


          {/* Marketplace Section */}
          <Box sx={{ mb: { xs: 10, sm: 14 } }}>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, justifyContent: 'space-between', gap: 2, mb: 4 }}>
              <Typography variant="h5" sx={{
                fontFamily: fonts.poppins,
                fontWeight: 700,
                color: colors.primary_dark,
              }}>
                {t("dashboard:exploreMarketplace")}
              </Typography>
              <Button 
                variant="outlined"
                endIcon={<IconChevronRight size={18} />}
                onClick={handleFindNowClick}
                sx={{
                  borderRadius: '12px',
                  textTransform: 'none',
                  fontFamily: fonts.poppins,
                  fontWeight: 600,
                  color: colors.primary,
                  borderColor: colors.primary,
                  px: 3,
                  '&:hover': {
                    backgroundColor: colors.primary + '10',
                    borderColor: colors.primary_dark,
                  }
                }}
              >
                {t("common:viewMore")}
              </Button>
            </Box>

            {isLoadingPlots ? (
              <SkeletonDashboard />
            ) : (
              <Grid container spacing={4} sx={{ mt: 2 }}>
                {displaySponsored && displaySponsored.length > 0 ? (
                  displaySponsored
                    .filter(plot => {
                      if (!homeSearchQuery.trim()) return true;
                      const q = homeSearchQuery.toLowerCase();
                      return (
                        (plot.subCategory || '').toLowerCase().includes(q) ||
                        (Array.isArray(plot.category) ? plot.category.join(' ') : plot.category || '').toLowerCase().includes(q) ||
                        (plot.taluka || '').toLowerCase().includes(q) ||
                        (plot.state || '').toLowerCase().includes(q)
                      );
                    })
                    .map((plot) => (
                    <Grid item xs={12} sm={6} md={4} key={plot._id}>
                      <UnifiedCropCard
                        crop={plot}
                        userData={userData}
                        onDetails={handleOpenDetails}
                        onGetContact={handleGetContact}
                        onDeleteSuccess={handleDeleteSuccess}
                        onEdit={handleEdit}
                        onBoost={() => handleBoost(plot)}
                        isExplore={true}
                      />
                    </Grid>
                  ))
                ) : (
                  <Box sx={{ width: '100%', textAlign: 'center', py: 8 }}>
                    <Typography sx={{ color: colors.text, fontFamily: fonts.poppins }}>
                      No crops found in your area.
                    </Typography>
                  </Box>
                )}
              </Grid>
            )}
            

          </Box>

          <Divider sx={{ mb: { xs: 10, sm: 14 } }} />

          {/* Services Section */}
          <Box sx={{ mb: { xs: 10, sm: 14 } }}>
            <Typography sx={{
              fontFamily: fonts.poppins,
              fontSize: { xs: '24px', md: '30px' },
              fontWeight: 700,
              color: colors.primary_dark,
              textAlign: 'center',
              mb: 6
            }}>
              {t("home-title1")}
            </Typography>

            <Grid container spacing={4} justifyContent="center">
              {[
                { img: "transport.png", label: t("service1") },
                { img: "pallet.png", label: t("service2") },
                { img: "labourer.png", label: t("service3") },
                { img: "market.png", label: t("service4") },
                { img: "traning.png", label: t("service5") },
                { img: "harrow.png", label: t("service6") },
              ].map((service, index) => (
                <Grid item xs={6} sm={4} md={2} key={index}>
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    gap: 2,
                    p: 2,
                    borderRadius: '24px',
                    transition: 'all 0.3s',
                    '&:hover': {
                      backgroundColor: '#FFFFFF',
                      boxShadow: '0px 10px 30px rgba(0,0,0,0.05)',
                      transform: 'translateY(-5px)'
                    }
                  }}>
                    <Box component="img" src={service.img} alt={service.label} sx={{ width: '80px', height: '80px', objectFit: 'contain' }} />
                    <Typography sx={{
                      fontFamily: fonts.poppins,
                      fontSize: '14px',
                      fontWeight: 600,
                      color: '#000000',
                      textAlign: 'center'
                    }}>
                      {service.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>

        </Box>

        
            {/* why use krushisetu section */}
            <Box sx={{ mb: { xs: 10, sm: 14 } }}>
              <Typography sx={{
                fontFamily: fonts.poppins,
                fontSize: { xs: '24px', md: '30px' },
                color: colors.primary_dark,
                fontWeight: 700,
                textAlign: "center",
                mb: 6
              }}>
                {t("home-title2")}
              </Typography>
              <Grid container spacing={4}>
                {[
                  { img: "block.jpg", title: t("reason1"), desc: t("desc1") },
                  { img: "list.jpg", title: t("reason2"), desc: t("desc2") },
                  { img: "field.jpg", title: t("reason3"), desc: t("desc3") },
                  { img: "agreement.jpg", title: t("reason4"), desc: t("desc4") },
                ].map((item, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Box sx={{ textAlign: "center", p: 3 }}>
                      <Box component="img" src={item.img} alt={item.title} sx={{ height: 80, width: 80, mb: 2, borderRadius: '24px', objectFit: 'contain' }} />
                      <Typography sx={{ fontFamily: fonts.poppins, fontSize: '18px', color: colors.primary_dark, fontWeight: 600, mb: 1 }}>
                        {item.title}
                      </Typography>
                      <Typography sx={{ fontFamily: fonts.poppins, fontSize: '14px', color: '#637381' }}>
                        {item.desc}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* We make different section */}
            <Box sx={{ mb: { xs: 10, sm: 14 }, textAlign: 'center' }}>
              <Typography sx={{
                fontFamily: fonts.poppins,
                fontSize: { xs: '24px', md: '30px' },
                color: colors.primary_dark,
                fontWeight: 700,
                mb: 6
              }}>
                {t("home-title3")}
              </Typography>
              <Grid container spacing={4} justifyContent="center">
                {[
                  { count: 1000000, prefix: "₹", suffix: "", label: t("count1Desc") },
                  { count: 100, suffix: "+", label: t("count2Desc") },
                  { count: 50, suffix: "+", label: t("count3Desc") },
                ].map((item, index) => (
                  <Grid item xs={12} sm={4} key={index}>
                    <Typography sx={{ fontFamily: fonts.poppins, fontSize: '48px', color: colors.primary_dark, fontWeight: 700 }}>
                      <CountUp start={0} end={item.count} duration={3} separator="," prefix={item.prefix || ""} suffix={item.suffix || ""} />
                    </Typography>
                    <Typography sx={{ fontFamily: fonts.poppins, fontSize: '16px', color: '#637381' }}>
                      {item.label}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* our customers love us section */}
            <Box sx={{ py: 8, px: 2, borderRadius: '24px', mb: { xs: 10, sm: 14 } }}>
              <Typography sx={{
                fontFamily: fonts.poppins,
                fontWeight: 700,
                fontSize: { xs: '24px', md: '30px' },
                color: colors.primary_dark,
                textAlign: "center",
                mb: 6
              }}>
                {t("home-title4")}
              </Typography>
              <Slider {...{
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: true,
                responsive: [
                  { breakpoint: 1024, settings: { slidesToShow: 2 } },
                  { breakpoint: 600, settings: { slidesToShow: 1 } }
                ]
              }}>
                {[
                  { name: "Suresh Patil", review: "Great platform for farmers!" },
                  { name: "Rahul Deshmukh", review: "Very easy to use." },
                  { name: "Amit Shah", review: "Best pricing for crops." },
                  { name: "Vijay K", review: "Highly recommended." }
                ].map((testimonial, index) => (
                  <Box key={index} sx={{ px: 2 }}>
                    <Paper sx={{ p: 4, borderRadius: '24px', boxShadow: '0px 10px 40px rgba(0,0,0,0.05)', textAlign: "center", height: '280px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                      <Rating value={5} readOnly size="small" sx={{ mb: 2 }} />
                      <Avatar sx={{ width: 64, height: 64, mb: 2, bgcolor: colors.primary }}>{testimonial.name[0]}</Avatar>
                      <Typography sx={{ fontWeight: 700, fontSize: '18px', color: colors.primary_dark, mb: 1 }}>{testimonial.name}</Typography>
                      <Typography sx={{ fontSize: '14px', fontStyle: 'italic', color: '#637381' }}>"{testimonial.review}"</Typography>
                    </Paper>
                  </Box>
                ))}
              </Slider>
            </Box>

            {/* download app section */}
            <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "center", justifyContent: "center", py: 10, gap: { xs: 5, md: 15 } }}>
              <Box component="img" src="iphone.jpg" alt="Mobile App" sx={{ width: { xs: 250, md: 400 }, height: 'auto', borderRadius: '24px', boxShadow: '0px 20px 60px rgba(0,0,0,0.1)' }} />
              <Box sx={{ maxWidth: 450, textAlign: { xs: 'center', md: 'left' } }}>
                <Typography sx={{ fontFamily: fonts.poppins, fontSize: { xs: '28px', md: '40px' }, fontWeight: 700, color: colors.primary_dark, mb: 3 }}>
                  {t("app1")}
                </Typography>
                <Typography sx={{ fontSize: '18px', color: '#637381', mb: 4 }}>
                  {t("app2")}<br />{t("app3")}
                </Typography>
                <Box 
                  component="img" 
                  src="googleplay.png" 
                  alt="Google Play" 
                  sx={{ width: 200, cursor: 'pointer', '&:hover': { opacity: 0.9 } }} 
                  onClick={() => window.open('https://play.google.com/store/apps/details?id=com.KrushisetuAgro.Krushisetu&hl=en_IN&pli=1', '_blank')}
                />
              </Box>
            </Box>

            {/* find plots and post plots section */}
            <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 4, mb: { xs: 10, sm: 14 } }}>
              <Box sx={{ flex: 1, p: 5, borderRadius: '24px', background: 'linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)', textAlign: 'center' }}>
                <Typography sx={{ fontWeight: 700, fontSize: '24px', color: colors.primary_dark, mb: 2 }}>{t("findPlots")}</Typography>
                <Typography sx={{ mb: 3, color: '#454F5B' }}>{t("plotsDesc1")}</Typography>
                <Button variant="contained" sx={{ bgcolor: colors.primary, borderRadius: '12px', px: 4, py: 1.5, textTransform: 'none', fontWeight: 700 }} onClick={() => navigate('/explore')}>{t("findNow")}</Button>
              </Box>
              <Box sx={{ flex: 1, p: 5, borderRadius: '24px', background: 'linear-gradient(135deg, #FFF9C4 0%, #FFF59D 100%)', textAlign: 'center' }}>
                <Typography sx={{ fontWeight: 700, fontSize: '24px', color: colors.primary_dark, mb: 2 }}>{t("listYourPlot")}</Typography>
                <Typography sx={{ mb: 3, color: '#454F5B' }}>{t("plotsDesc2")}</Typography>
                <Button variant="contained" sx={{ bgcolor: colors.primary_dark, borderRadius: '12px', px: 4, py: 1.5, textTransform: 'none', fontWeight: 700 }} onClick={handleFreePostingClick}>{t("freePosting")}</Button>
              </Box>
            </Box>

        {/* Footer */}
        <Box sx={{ background: '#F4F7F4', p: { xs: 3, md: 8 }, borderTop: '1px solid #E0E5EB' }}>
            <Box sx={{ maxWidth: 1400, margin: "0 auto", display: "flex", flexDirection: { xs: "column", md: "row" }, gap: { xs: 5, md: 10 } }}>
                <Box sx={{ flex: 1.5 }}>
                    <img src={KrushiSetu} alt="Logo" style={{ width: 180, marginBottom: 16, mixBlendMode: 'multiply' }} />
                    <Typography sx={{ opacity: 0.8, fontSize: 14, fontFamily: fonts.poppins, maxWidth: 350, lineHeight: 1.6, color: '#454F5B' }}>
                        {t("home-title")}
                    </Typography>
                </Box>
                
                <Box sx={{ flex: 2 }}>
                    <Typography sx={{ mb: 3, fontWeight: 700, fontFamily: fonts.poppins, fontSize: '18px', color: colors.primary_dark }}>
                        {t("quickLinks")}
                    </Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            <Typography sx={{ fontSize: 14, cursor: 'pointer', transition: '0.2s', '&:hover': { color: colors.primary, transform: 'translateX(5px)' } }} onClick={aboutUsPage}>{t("aboutUs")}</Typography>
                            <Typography sx={{ fontSize: 14, cursor: 'pointer', transition: '0.2s', '&:hover': { color: colors.primary, transform: 'translateX(5px)' } }} onClick={() => navigate('/explore')}>{t("explore")}</Typography>
                            <Typography sx={{ fontSize: 14, cursor: 'pointer', transition: '0.2s', '&:hover': { color: colors.primary, transform: 'translateX(5px)' } }} onClick={wishlistPage}>{t("wishlist")}</Typography>
                            <Typography sx={{ fontSize: 14, cursor: 'pointer', transition: '0.2s', '&:hover': { color: colors.primary, transform: 'translateX(5px)' } }} onClick={viewedPlotsPage}>{t("viewedPlots")}</Typography>
                            <Typography sx={{ fontSize: 14, cursor: 'pointer', transition: '0.2s', '&:hover': { color: colors.primary, transform: 'translateX(5px)' } }} onClick={() => navigate(isSeller ? '/farmer/boost' : '/buyer/boost')}>{t("subscription")}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            <Typography sx={{ fontSize: 14, cursor: 'pointer', transition: '0.2s', '&:hover': { color: colors.primary, transform: 'translateX(5px)' } }} onClick={termsConditionPage}>{t("termsConditions")}</Typography>
                            <Typography sx={{ fontSize: 14, cursor: 'pointer', transition: '0.2s', '&:hover': { color: colors.primary, transform: 'translateX(5px)' } }} onClick={privacyPolicyPage}>{t("privacyPolicy")}</Typography>
                            <Typography sx={{ fontSize: 14, cursor: 'pointer', transition: '0.2s', '&:hover': { color: colors.primary, transform: 'translateX(5px)' } }} onClick={faqsPage}>{t("faqs")}</Typography>
                            <Typography sx={{ fontSize: 14, cursor: 'pointer', transition: '0.2s', '&:hover': { color: colors.primary, transform: 'translateX(5px)' } }} onClick={supportPage}>{t("support")}</Typography>
                            <Typography sx={{ fontSize: 14, cursor: 'pointer', transition: '0.2s', '&:hover': { color: colors.primary, transform: 'translateX(5px)' } }} onClick={settingsPage}>{t("settings")}</Typography>
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ flex: 1 }}>
                    <Typography sx={{ mb: 3, fontWeight: 700, fontFamily: fonts.poppins, fontSize: '18px', color: colors.primary_dark }}>
                        {t("ContactUs")}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: colors.primary + '15', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Email sx={{ fontSize: 18, color: colors.primary }} />
                            </Box>
                            <Typography sx={{ fontSize: 14, color: '#454F5B' }}>krushisetuofficial@gmail.com</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: colors.primary + '15', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Phone sx={{ fontSize: 18, color: colors.primary }} />
                            </Box>
                            <Typography sx={{ fontSize: 14, color: '#454F5B' }}>+91 7040180680</Typography>
                        </Box>
                        
                        <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                            {[
                                { icon: <Facebook />, link: '#' },
                                { icon: <Instagram />, link: '#' },
                                { icon: <LinkedIn />, link: '#' }
                            ].map((social, index) => (
                                <IconButton 
                                    key={index}
                                    sx={{ 
                                        p: 1, 
                                        color: colors.primary_dark,
                                        bgcolor: '#FFFFFF',
                                        boxShadow: '0px 4px 10px rgba(0,0,0,0.05)',
                                        '&:hover': { 
                                            bgcolor: colors.primary, 
                                            color: '#FFFFFF',
                                            transform: 'translateY(-3px)'
                                        },
                                        transition: 'all 0.3s'
                                    }}
                                >
                                    {social.icon}
                                </IconButton>
                            ))}
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Divider sx={{ mt: 8, mb: 4, opacity: 0.6 }} />
            <Typography sx={{ textAlign: 'center', fontSize: 13, color: '#637381', fontFamily: fonts.poppins }}>
                © {new Date().getFullYear()} Krushi Setu. {t("dashboard:madeWithLove")}
            </Typography>
        </Box>
      </Box>

      {/* Login Dialog */}
      <Dialog open={openLogin} onClose={handleCloseLogin} fullWidth maxWidth="sm">
          <IconButton onClick={handleCloseLogin} sx={{ position: "absolute", right: 10, top: 10 }}><Close /></IconButton>
          <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={KrushiSetu} alt="logo" style={{ width: 150, marginBottom: 20, mixBlendMode: 'multiply' }} />
              <SignUp onClose={handleCloseLogin} />
          </Box>
      </Dialog>

      <ContactPopup
          open={openPopup}
          onClose={() => { setIsChange(!isChange); setOpenPopup(false); }}
          plot={selectedPlot}
      />

      {addPlots && (
        <Modal open={true} onClose={() => setAddPlots(false)}>
           <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '90%', maxHeight: '90vh', bgcolor: 'background.paper', borderRadius: 4, p: 4, overflowY: 'auto' }}>
              <AddPlots role={role} userData={userData} setAddPlots={setAddPlots} />
           </Box>
        </Modal>
      )}
    </>
  );
};

export default Home;
